import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/UploadedItem.module.css";

const UploadedItem = ({ name, onDelete }) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className={styles.attachmentItems}>
      <div className="fw-bold text-truncate">Uploaded: {name}</div>
      {/* <i onClick={onDelete} className="bi bi-trash mr-2"></i> */}
    </div>
  );
};

/* required: display name */
UploadedItem.displayName = "UploadedItem";

/* required: props types */
UploadedItem.propTypes = {};

/* required: default props */
UploadedItem.defaultProps = {};

export { UploadedItem };
